import * as THREE from 'three';
import { EdgesGeometry } from 'three';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';
import {  hesaplaAgirlik, hesaplaAlan, hesaplaHacim } from '../FikoYT-Fonksiyonlar';
import { fikoObjeyiStlIndir } from './FikoSTLDisaAktar';
import { fikoObjeyiStepIndir, fikoStepAyarlariniDuzenle } from './FikoSTEPDisaAktar';

export class FikoCizimSTL extends FikoGrup {
    override type: any = "FikoCizimSTL";
    /** */
    sayac = 1;

    override komutlar = [
        {
            isim: "Gizle / Göster",
            simge: "eye",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.ciz();
            }
        },
        {
            isim: "STL olarak indir",
            simge: "download",
            tiklandi: () => {
                try { fikoObjeyiStlIndir(this, this.name); }
                catch (e: any) {
                    console.error('STL disa aktarim hatasi', e);
                    alert('STL olarak aktarilamadi: ' + (e?.message || e));
                }
            }
        },
        {
            isim: "STEP olarak indir (B-Rep)",
            simge: "download",
            tiklandi: async () => {
                try { await fikoObjeyiStepIndir(this, 'brep', this.name); }
                catch (e: any) {
                    console.error('STEP (B-Rep) disa aktarim hatasi', e);
                    alert('STEP olarak aktarilamadi: ' + (e?.message || e));
                }
            }
        },
        {
            isim: "STEP olarak indir (AP242 Tessellated)",
            simge: "download",
            tiklandi: async () => {
                try { await fikoObjeyiStepIndir(this, 'tessellated', this.name); }
                catch (e: any) {
                    console.error('STEP (Tessellated) disa aktarim hatasi', e);
                    alert('STEP olarak aktarilamadi: ' + (e?.message || e));
                }
            }
        },
        {
            isim: "STEP ayarları...",
            simge: "cog",
            tiklandi: () => { fikoStepAyarlariniDuzenle(); }
        }
    ]

    public override get liste(): any[] {
        return this.children;
    }


    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/stl.webp";
    }

    dosyadan(dosya: any) {
        let _this = this;


        const loader: STLLoader = new STLLoader();

        let colors: any[] = []

        loader.load(URL.createObjectURL(dosya), function (geometry: THREE.BufferGeometry) {
            var material = new THREE.MeshPhongMaterial({
                color: 0xd2d2ff, vertexColors: true, /*side: THREE.DoubleSide, shadowSide: THREE.DoubleSide,*/ polygonOffset: true,
                polygonOffsetFactor: 1, // positive value pushes polygon further away
                polygonOffsetUnits: 1,
            });
            var mesh = new THREE.Mesh(geometry, material);
            /** */
            let renk = new THREE.Color(0xd2d2ff)
            for (let i = 0; i < mesh.geometry.attributes["position"].count; i++) {
                // const element = mesh.geometry.attributes["position"].array[i];
                colors.push(...[renk.r, renk.g, renk.b])
            }
            mesh.geometry.setAttribute("color", new THREE.Float32BufferAttribute(colors, 3));
            /** */


            _this.add(mesh);

            var edge: EdgesGeometry = new EdgesGeometry(geometry);
            var edgeLine = new THREE.LineSegments(edge, new THREE.LineBasicMaterial({ color: 0x000000 }));
            // edgeLine.renderOrder = 1;

            mesh.add(edgeLine);

            _this.sahne.anaGosterim.FikoYT.degisti.emit();
            _this.sahne.anaGosterim.ciz();
        });
        return this;
    }

}